const $ = require('jquery');
window.$ = $;

import './assets/styles/sanitize.css';
import './assets/styles/styles.less';

import Vue from 'vue'
import App from './App';
import store from './store';

new Vue({
	el: '#app',
	store,
	render: h => h(App)
});